/**
 * Console PIX fee slot helpers. Inherit hydrates from the account-owner
 * catalog (`catalog_instance_id`), same GET `/v1/instances/{id}/pix/fees`
 * as Administração → Limites PIX.
 */

const toFeeNumber = (...values) => {
  for (const value of values) {
    const n = Number(value);
    if (Number.isFinite(n) && n >= 0) return n;
  }
  return 0;
};

export const readAccountPixFeeSlot = (payer, operation = "enviado") => {
  const op = String(operation || "enviado").trim().toLowerCase();
  const root = payer?.data && typeof payer.data === "object" ? payer.data : payer;
  if (!root || typeof root !== "object") return null;
  if (op === "recebido") {
    return root.recebido || root.Recebido || null;
  }
  return root.enviado || root.Enviado || null;
};

export const readPixFeeCatalogInstanceId = (slot) => {
  const raw = slot?.catalog_instance_id ?? slot?.catalogInstanceId;
  const n = Number(raw);
  return Number.isInteger(n) && n > 0 ? n : null;
};

export const readPixFeeCatalogInstanceName = (slot) => {
  const name = String(
    slot?.catalog_instance_name ?? slot?.catalogInstanceName ?? "",
  ).trim();
  return name || null;
};

/** GET pix/fees target: owner catalog when present, else the console card. */
export const resolvePixFeeHydrateInstance = (selectedInstance, slot) => {
  const catalogId = readPixFeeCatalogInstanceId(slot);
  if (!catalogId) return selectedInstance;
  if (Number(selectedInstance?.baasInstanceId) === catalogId) return selectedInstance;
  return { ...selectedInstance, baasInstanceId: catalogId };
};

export const pixFeeSlotAmountsEmpty = (slot) => {
  const overlayPct = toFeeNumber(
    slot?.instance_fee_percent,
    slot?.instanceFeePercent,
    slot?.fee_percent,
    slot?.feePercent,
  );
  const overlayFixed = toFeeNumber(
    slot?.instance_fee_fixed,
    slot?.instanceFeeFixed,
    slot?.fee_fixed,
    slot?.feeFixed,
  );
  const costPct = toFeeNumber(
    slot?.instance_cost_percent,
    slot?.instanceCostPercent,
    slot?.cost_percent,
    slot?.costPercent,
  );
  const costFixed = toFeeNumber(
    slot?.instance_cost_fixed,
    slot?.instanceCostFixed,
    slot?.cost_fixed,
    slot?.costFixed,
  );
  return overlayPct === 0 && overlayFixed === 0 && costPct === 0 && costFixed === 0;
};

export const mergeInstancePixFeePolicyIntoSlot = (slot, policy) => {
  if (!policy) return slot || {};
  const feePercent = toFeeNumber(policy.fee_percent, policy.feePercent);
  const feeFixed = toFeeNumber(policy.fee_fixed, policy.feeFixed);
  const costPercent = toFeeNumber(policy.cost_percent, policy.costPercent);
  const costFixed = toFeeNumber(policy.cost_fixed, policy.costFixed);
  return {
    ...(slot || {}),
    inherit_fees: true,
    instance_fee_percent: feePercent,
    instance_fee_fixed: feeFixed,
    instance_cost_percent: costPercent,
    instance_cost_fixed: costFixed,
    fee_percent: feePercent,
    fee_fixed: feeFixed,
    cost_percent: costPercent,
    cost_fixed: costFixed,
  };
};

export const findInstancePixFeePolicy = (instanceFees, operation = "enviado") => {
  const op = String(operation || "enviado").trim().toLowerCase();
  const policies = Array.isArray(instanceFees?.policies)
    ? instanceFees.policies
    : Array.isArray(instanceFees?.Policies)
      ? instanceFees.Policies
      : [];
  return policies.find((item) => {
    const type = String(item?.operation_type || item?.operationType || "")
      .trim()
      .toLowerCase();
    return type === op;
  }) || null;
};
